<div class="pad-top-30">
  @if (searchContext !== SEARCH_CONTEXT.DRP_SHOP_SEARCH) {
    <div class="detailed">
      <p class="pad-bottom-0 font-weight-bold">
        We can’t find any shops matching your search terms.
      </p>
      <p>Try searching for a location again.</p>
      <p>
        If it doesn’t appear, don’t worry — you can still select a specific repair shop when our
        representative contacts you.
      </p>
      <p class="cancel-link">
        <a (click)="cancel.emit()">
          @if (searchContext === SEARCH_CONTEXT.DRP_SHOP_SELECTION) {
            <span>Select a Repair Shop later</span>
          }
          @if (searchContext === SEARCH_CONTEXT.RENTAL_SELECTION) {
            <span>Select a Rental Location later</span>
          }
        </a>
      </p>
    </div>
  } @else {
    Simple: No shops were found in your area
  }
</div>
